import styled from 'styled-components';
import Box, { Flex } from '@spotnana/pixel-react/dist/Box';
import Typography from '@spotnana/pixel-react/dist/Typography';
import { css } from '@emotion/react';
import { paddings, themed } from '@spotnana/blocks/src/utils/styling';

export const PolicyContainer = styled(Box)`
  margin-top: 24px;
`;

export const ViolatonsContainer = styled(Box)`
  margin-top: 16px;
`;

export const FareChangeNote = styled(Typography).attrs({
  variation: 'body',
  fontWeight: 'regular',
  lineHeight: '24px',
})``;

export const FareContainer = styled(Flex)`
  margin-bottom: 24px;
  justify-content: space-between;
`;

export const BreakupDivider = styled(Box)`
  border: 1px solid ${({ theme }) => theme.colors.border.grey10};
  height: 0px;
  margin: 16px 0px;
`;
export const fare_change_alert_card = themed(
  ({ palette }) => css`
    background-color: ${palette.surface.base};
    box-shadow: ${palette.shadow.cardShadow};
    ${paddings.x.p1point5}
    ${paddings.y.p1point5}
    border-radius:8px;
  `,
);
